import { render, staticRenderFns } from "./ReservationColumnGroupEdit.vue?vue&type=template&id=73338f16&scoped=true&"
import script from "./ReservationColumnGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnGroupEdit.vue?vue&type=style&index=0&id=73338f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73338f16",
  null
  
)

export default component.exports